import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';

export class Ad4qCdmDeviceBehaviorPlugin extends DefaultCdmDeviceBehaviorPlugin {
	public override readonly models: DeviceModel[] = [
		DeviceModel.AD4Q,
		DeviceModel.AD4QA,
		DeviceModel.AD4QB,
		DeviceModel.AD4QC,
		DeviceModel.AD4QD,
		DeviceModel.AD4QE,
		DeviceModel.AD4QF,
		DeviceModel.AD4QP55,
		DeviceModel.AD4QR52
	];

	public hideIdentifyAllButton(): boolean {
		return true;
	}

	public hideIpConfiguration(): boolean {
		return true;
	}
}
